import {Box, Flex} from 'exsportia-components'
import {FC, useEffect, useMemo, useState} from 'react'
import {useQuery} from 'react-query'
import {useSelector} from 'react-redux'
import {Outlet} from 'react-router-dom'

import {DisplaySettingsQueries} from '../api/display-settings'
import {useVenue} from '../api/venue/hooks'
import {ServiceNoticeBanner} from '../components/service-notice-banner/service-notice-banner'
import {GlobalService} from '../services/global'
import {PaymentProviderProvider} from '../services/payments/hooks/payment-provider-form.provider'
import {brandFontOf, brandFontStack, brandPageBackground} from '../theme/venue-brand/brand-theme'
import {VenueBrandTheme} from '../theme/venue-brand/venue-brand-theme'
import {PreFooter} from './components/pre-footer'
import {Footer} from './footer'
import {Header} from './header'

export const Layout: FC = () => {
  const language = useSelector(GlobalService.selectors.language())
  const {data: venueData} = useVenue()
  useEffect(() => {
    if (venueData) {
      document.title = venueData.name
      localStorage.setItem('lastVisitedVenueId', venueData.uid)
    }
  }, [venueData])
  const [bgImageURL, setBgImageURL] = useState<string | null>(null)
  // D257: a venue may paint a solid colour behind its page instead of the cover photo (set in VMS
  // Display Settings). Read off the appearance template, like the schedule switch.
  const {data: baseSettings} = useQuery(
    DisplaySettingsQueries.getAppearanceBaseSettingsQuery({
      params: {id: venueData?.appearanceTemplateId},
      enabled: Boolean(venueData?.appearanceTemplateId),
      staleTime: 1000 * 60,
    }),
  )
  // The venue's brand background (Settings → Branding) wins over the template's colour and the cover photo.
  const pageBackground = brandPageBackground(venueData) || baseSettings?.pageBackgroundColor || null
  const brandFont = brandFontStack(brandFontOf(venueData))
  useEffect(() => {
    if (venueData?.media) {
      setBgImageURL(venueData.media[venueData.thumbIndex || 0]?.secure_url || '')
    }
  }, [venueData])

  return useMemo(
    () => (
      <VenueBrandTheme venue={venueData}>
        <Flex
          position='relative'
          minHeight={'100dvh'}
          backgroundSize='cover'
          flexDirection={'column'}
          backgroundPosition='center'
          justifyContent={'space-between'}
          background={pageBackground || `url(${bgImageURL}) no-repeat fixed`}
          fontFamily={brandFont}
        >
          <Box>
            <ServiceNoticeBanner />
            <Header />
            <PaymentProviderProvider>
              <Outlet />
            </PaymentProviderProvider>
          </Box>
          <PreFooter />
          <Footer />
        </Flex>
      </VenueBrandTheme>
    ),
    [language, venueData, bgImageURL, pageBackground],
  )
}
